export const common =
{
  width: '640px'
}

export const web =
{
  ...common,

  width: '512px'
}

export const tablet =
{
  ...common
}
